import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  categoryShopIcon,
  clientIcon,
  coldIcon,
  payoutIcon,
} from "../../utils/historyIcons/historyIcons";
import {
  IsAllow,
  ValidatePermission,
} from "../../utils/allowHelper/AllowHelper";
import { useTranslator } from "../../context/translator";
import { PERMISSION_CODE } from "../../utils/enum/enums";
import { useGetCompanyQuery, useGetUserByIdQuery } from "store/api/apiSlice";

const ClientMenu = ({ children }) => {
  const { translate } = useTranslator();
  const { user } = useSelector((state) => state.user);

  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: company, isLoading: companyLoading } = useGetCompanyQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );

  const allow = company?.allow || {};

  const menuOptions = [
    {
      key: "clients",
      name: IsAllow(allow, "customer-02")
        ? translate("shops")
        : translate("customers"),
      link: "/clients",
      icon: clientIcon("30px", "30px"),
      permission: [PERMISSION_CODE.ACCESS_CUSTOMERS],
      requiresSB: false,
    },
    {
      key: "cold-accounts",
      name: translate("cold-accounts"),
      link: "/clients/cold",
      icon: coldIcon("30px", "30px"),
      permission: [PERMISSION_CODE.VIEW_SPECIAL_CUSTOMERS],
      requiresSB: true,
    },
    {
      key: "deposit-types",
      name: translate("deposit"),
      link: "/clients/deposit",
      icon: payoutIcon("30px", "30px"),
      permission: [PERMISSION_CODE.VIEW_DEPOSIT_TYPES],
      requiresSB: true,
    },
    {
      key: "categories",
      name: translate("categories"),
      link: "/clients/categories",
      icon: categoryShopIcon("30px", "30px"),
      permission: [PERMISSION_CODE.VIEW_CUSTOMER_CATEGORIES],
      requiresSB: false,
    },
  ];

  const baseLinkClass =
    "flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group";

  const sidebarButtonClasses =
    "inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600";

  const sidebarClasses =
    "fixed top-0 left-0 z-10 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0 border-r border-gray-200 bg-white dark:bg-gray-800 dark:border-gray-700";

  if (userLoading || companyLoading) return null;

  return (
    <>
      <button
        data-drawer-target="default-sidebar"
        data-drawer-toggle="default-sidebar"
        aria-controls="default-sidebar"
        type="button"
        className={sidebarButtonClasses}
      >
        {/*  className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden 
          hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 
          dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"  */}

        <span className="sr-only">Open sidebar</span>
        <svg
          className="w-6 h-6"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            clipRule="evenodd"
            fillRule="evenodd"
            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
          />
        </svg>
      </button>

      <aside
        id="default-sidebar"
        className={sidebarClasses}
        aria-label="Sidebar"
      >
        <div className="h-20"></div>
        <div className="h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800">
          <ul className="space-y-2 font-medium">
            {menuOptions.map((option) => {
              const canView =
                ValidatePermission(userProfile?.user, option.permission) &&
                (!option.requiresSB || IsAllow(allow, "SBFields"));

              if (!canView) return null;

              return (
                <li key={option.key}>
                  <Link to={option.link} className={baseLinkClass}>
                    {option.icon}
                    <span className="flex-1 ms-3 whitespace-nowrap">
                      {option.name}
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </aside>

      <div className="p-4 sm:ml-64">{children}</div>
    </>
  );
};

export default ClientMenu;
